import { getBackendOrigin } from "@/lib/api"

const DEFAULT_POSTHOG_HOST = "https://s.thecompany.money"
const DEFAULT_POSTHOG_UI_HOST = "https://us.posthog.com"

export const POSTHOG_DEFAULTS = "2026-01-30"

export function getPostHogEnvironment() {
  return (import.meta.env.VITE_POSTHOG_ENVIRONMENT || "local").trim() || "local"
}

export function getPostHogProjectToken() {
  return (import.meta.env.VITE_POSTHOG_PROJECT_TOKEN || "").trim()
}

export function getPostHogHost() {
  return (import.meta.env.VITE_POSTHOG_HOST || DEFAULT_POSTHOG_HOST).trim() || DEFAULT_POSTHOG_HOST
}

export function getPostHogUiHost() {
  return (import.meta.env.VITE_POSTHOG_UI_HOST || DEFAULT_POSTHOG_UI_HOST).trim() || DEFAULT_POSTHOG_UI_HOST
}

export function getPostHogTracingHeaders() {
  return [
    ...new Set(
      [window.location.hostname, getUrlHostname(getBackendOrigin()), "localhost"].filter(
        (hostname): hostname is string => Boolean(hostname),
      ),
    ),
  ]
}

function getUrlHostname(url: string) {
  try {
    return new URL(url).hostname
  } catch {
    return ""
  }
}
